import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "./TitleDivSeo.css"
// import { useContext } from 'react';
// import { StatusContext } from '../ContextApiStatus';

function HaveXmlOrNot(props) {



    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
         <h3>خريطة موقع ال XML</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          {props.CheckForSiteMap ? "جيد لديك ملف خريطة موقع XML" : "لا يوجد لديك ملف موقع XML"}
        </Typography>
        <Typography fontWeight="md" level="body-sm">
            <a target='_blank' href={props.UrlForSiteMap}>
            {props.UrlForSiteMap}
            </a>
        </Typography>
      </CardContent>

      { props.CheckForSiteMap === true ?
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> :
   <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          يسرد ملف Sitemap عناوين URL المتاحة للزحف ويمكن أن يتضمن معلومات إضافية مثل آخر تحديثات موقعك وتكرار التغييرات وأهمية عناوين URL. هذا يسمح لمحركات البحث بالزحف إلى الموقع بشكل أكثر ذكاء.
نوصي بإنشاء ملف Sitemap بتنسيق XML لموقعك على الويب وإرساله إلى كل من Google Search Console وأدوات مشرفي المواقع Bing. من الممارسات الجيدة أيضا تحديد موقع ملف Sitemap في برامج الروبوت الخاصة بك .txt file.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default HaveXmlOrNot